export enum PaymentMethod {
    CARD = 1,
    SUBSIDY = 2,
    GOOGLE_PAY = 3,
    APPLE_PAY = 4
}